module.exports = __webpack_public_path__ + "img/icon-arrow-dropdown.db3bd6c9.svg";